import { render, staticRenderFns } from "./ImoFalForm5MenuGrid.vue?vue&type=template&id=d072c618"
import script from "./ImoFalForm5MenuGrid.vue?vue&type=script&lang=js"
export * from "./ImoFalForm5MenuGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports